'use strict';

import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { config, STATICS } from './modules/syos-config';

(function() {
    'use strict';

    let productionSeasonNo = null;
    let performanceNo = null;

    function isSYOSPage() {
        // const url = 'https://writ-tnew-test.tnhs.cloud/8004/8102';
        // const url = 'https://my.writerstheatre.org/7589/7729';
        // const parsedUrl = new URL(url);
        const parsedUrl = new URL(window.location.href);
        const pathName = parsedUrl.pathname;

        // check 'z' param (zoneId) (indicates that it's BA screen)
        if (parsedUrl.searchParams.has('z')) {
            console.log('Best Available Screen');

            return false;
        }

        // check path (match prod/perf no's)
        const regEx = /^\/(?<ProdSeasonNo>\d+)\/?(?<PerfNo>\d+)?\/?/;
        let found = pathName.match(regEx);

        if (found) {
            productionSeasonNo = found.groups.ProdSeasonNo;
            performanceNo = found.groups.PerfNo;
            return true;
        }

        // Check the content of the page to see if there is a performanceId
        // found = find(document.querySelectorAll('script'), el => el.innerText.match(/var performanceId = (\d+);/));
        found = Array.from(document.querySelectorAll('script')).find(el => el.innerText.match(/var performanceId = (\d+);/));
        if (found) {
            performanceNo = found.innerText.match(/var performanceId = (?<PerfNo>\d+);/).groups.PerfNo;
            return true;
        }
        return false;
    }

    /**
     * Checks the response of the WebContent call and if the seat curve is disabled then will throw a message
     *   Throwing the message stop the initialisation of SeatCurve
     */
    function checkWebContentForSeatCurveDisabled(perfNo) {
        return fetchPolyfill(`${STATICS.PROXY}/TXN/WebContents?productionElementIds=${perfNo}`)
            .then(response => response.json())
            .then(webContentData => {
                webContentData.forEach(item => {
                    item.WebContents.forEach(item => {
                        if (
                            item.Type.Description.toLowerCase() === STATICS.SEAT_CURVE_WEB_CONTENT_DESCRIPTION
                            &&
                            item.Value.toLowerCase() === 'false'
                        ) {
                            throw 'Seat Curve DISABLED!';
                        }
                    });
                });
            });
    }

    async function run() {
        let perf = null;

        try {
            const sessionKey = await fetchPolyfill(`${STATICS.TNEW}/api/session/sessionkey/`)
                .then(response => response.json()
                .then(async response => {
                    return await fetchPolyfill(`${STATICS.PROXY}/decrypt`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ key: response.encryptedSessionKey }),
                    })
                    .then(response => response.json());
                })
            );

            // const sessionKey = '5713e664e5ef44b58b5e08dd5fee3db200000000000000000000000000000000'

            if (performanceNo) {
                perf = await fetchPolyfill(`${STATICS.PROXY}/TXN/Performances/${performanceNo}`)
                    .then(response => response.json());
                await checkWebContentForSeatCurveDisabled(performanceNo);

            } else {
                perf = await fetchPolyfill(`${STATICS.PROXY}/TXN/Performances?productionSeasonId=${productionSeasonNo}`)
                    .then(response => response.json())
                    .then(response => response[0]);

                await checkWebContentForSeatCurveDisabled(perf.Id);
            }

            const baLinkEl = document.querySelector('.tn-ticketing-mode-change__anchor');
            if (baLinkEl) {
                config.features.bestAvailableLink = {
                    enabled: true,
                    url: baLinkEl.getAttribute('href'),
                    labelText: baLinkEl.innerText,
                };
            }

            window.SYOSConfig = config;

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `${STATICS.SYOS}/dist/syos-style.css`;
            document.head.appendChild(link);

            const carryOverEls = document.querySelectorAll('.carry-over');
            document.body.innerHTML = '<div id="syos-root">Initializing SeatCurve...</div>';

            const script = document.createElement('script');
            script.src = `${STATICS.SYOS}/dist/syos-bundle.js`;
            script.async = true;
            document.head.appendChild(script);
            script.onload = () => {
                carryOverEls.forEach(el => {
                    document.body.appendChild(el);
                });

                const syosApp = new SYOS({ // eslint-disable-line no-undef
                    initialPerfNo: perf.Id,
                    initialFacilityNo: perf.Facility.Id,
                    initialSessionKey: sessionKey,
                    endpoint: `${STATICS.PROXY}`,
                    enableSocialDistancing: false,
                    onComplete: function () {
                        window.location.href = `${STATICS.TNEW}/Cart/Details`;
                    }
                });

                var rootEl = document.getElementById('syos-root');
                syosApp.run(rootEl);
            };
        } catch (error) {
            console.error('error', error);
        } finally {
            document.body.classList.add('tnew-loaded');
        }
    }

    function init() {
        if (isSYOSPage()) {
            if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
                run();
            } else {
                document.addEventListener('DOMContentLoaded', run);
            }
        } else {
            document.body.classList.add('tnew-loaded');
        }
    }

    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(init, 1);
    } else {
        document.addEventListener("DOMContentLoaded", init);
    }
})()
